export default __webpack_public_path__ + "static/BuildOn-e0fe0ebde1346165a085ef4d676f6959.jpg";